<!--
  黑金 V2 · 下单成功
  目录：views/SelfHelp/blackV2
-->
<template>
  <div class="bv2-success">
    <main class="bv2-success-main">
      <div class="bv2-success-icon" aria-hidden="true">
        <span></span>
      </div>
      <div class="bv2-success-copy">
        <p>点菜成功</p>
        <h1>美味制作中</h1>
        <span>后厨正在为您精心准备，请耐心等待</span>
      </div>
      <button type="button" class="bv2-detail-btn" @click="handleToDetail">
        查看消费明细
      </button>
    </main>
  </div>
</template>

<script>
import BlackPlaceOrderSuccess from "../BlackPlaceOrderSuccess.vue";
import { getBlackRecordConsumeRouteName } from "@/utils";

export default {
  name: "BlackPlaceOrderSuccessV2",
  extends: BlackPlaceOrderSuccess,
  methods: {
    handleToDetail() {
      this.$router.replace({ name: getBlackRecordConsumeRouteName() });
    },
  },
};
</script>

<style lang="scss" scoped>
$gold: #ffc653;
$btn-text: #20201e;

.bv2-success {
  width: 100%;
  min-height: 100vh;
  padding: 0 32px calc(42px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #fff;
  background: #000 url("~@/assets/black-micropoint/bg.png") center top / 100%
    auto no-repeat;
  color-scheme: dark;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.bv2-success-main {
  display: flex;
  min-height: calc(100vh - 42px - env(safe-area-inset-bottom));
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bv2-success-icon {
  position: relative;
  display: flex;
  width: 240px;
  height: 240px;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 198, 83, 0.72);
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 198, 83, 0.24) 0,
    rgba(82, 68, 36, 0.56) 56%,
    rgba(0, 0, 0, 0.72) 100%
  );
  transform: translateY(-40px);

  span {
    width: 80px;
    height: 44px;
    border-bottom: 10px solid $gold;
    border-left: 10px solid $gold;
    transform: translateY(-10px) rotate(-45deg);
  }
}

.bv2-success-copy {
  text-align: center;

  p {
    margin: 0;
    font-size: 32px;
  }

  h1 {
    margin: 10px 0 0;
    color: $gold;
    font-size: 40px;
    font-weight: 600;
  }

  span {
    display: block;
    margin-top: 20px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 26px;
  }
}

.bv2-detail-btn {
  position: fixed;
  z-index: 10;
  right: 5%;
  bottom: calc(40px + env(safe-area-inset-bottom));
  left: 5%;
  width: 90%;
  height: 78px;
  border: 0;
  border-radius: 10px;
  color: $btn-text;
  background: linear-gradient(180deg, #ffd56f 0%, $gold 45%, #f2cb78 100%);
  font-size: 30px;
  font-weight: 600;
}
</style>
